import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBanStatus } from '@/hooks/useBanStatus';
import { Loader2 } from 'lucide-react';
import { useAlbumNavigation } from "@/hooks/useAlbumNavigation";

interface BannedUserRouteProps {
  children: React.ReactNode;
}

const BannedUserRoute: React.FC<BannedUserRouteProps> = ({ children }) => {
  const { isBanned, loading } = useBanStatus();
  const location = useLocation();
  const { getAlbumPath, loading: albumLoading } = useAlbumNavigation();

  if (loading || albumLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-primary" />
          <p className="text-muted-foreground">Verificando permisos...</p>
        </div>
      </div>
    );
  }

  // If user is banned and not on the main page, redirect to main page
  if (isBanned && location.pathname !== '/') {
    const inicioPath = getAlbumPath("/inicio");
    return <Navigate to={inicioPath || "/"} replace />;
  }

  return <>{children}</>;
};

export default BannedUserRoute;